import React from 'react';
import { JobUploadFile } from '../../store/selectors/jobsSelectors';
import { EngagementExpandedSummary } from '../../models/dto/engagement';
import { CallDetails } from '../../models/dto/call';
import TethrCallLink from './TethrCallLink';
import { CallAudioUploadFailure } from '../../store/state/callAudioUploadState';

export default function JobDetailsFileStatus(props: { file: JobUploadFile; engagement: EngagementExpandedSummary; }) {
	switch (props.file.type) {
		case 'uploading':
			return <div>{props.file.details.status === 'queued' ? 'Preparing upload' : 'Uploading'}</div>;
		case 'uploaded':
			return renderUploadedCallStatus(props.file.details, props.engagement);
		case 'failure':
			return (
				<div>
					<div className="text-red">{getFailureLabel(props.file.details)}</div>
					<div className="mt-1">{props.file.details.description}</div>
				</div>
			);
	}
}

function renderUploadedCallStatus(call: CallDetails, engagement: EngagementExpandedSummary) {
	if (!call.statusId)
		return <div></div>;
	
	switch (call.statusId) {
		case 'Uploading':
		case 'NotStarted':
			return <div></div>;
		case 'Complete':
			if (engagement.showTethrAppIntegration) {
				return <TethrCallLink call={call} tethrUrl={engagement.tethrUrl} hasLinkText="Complete - View call" noLinkText="Complete" />;
			} else {
				return <div>Complete</div>
			}
		case 'Processing':
			return <div>Processing</div>;
		case 'Rejected':
			return <div className="text-red">Unsupported call</div>;
	}
}

function getFailureLabel(failure: CallAudioUploadFailure): string {
	switch (failure.failureType) {
		case 'quotaReached':
			return 'Quota reached';
		case 'serverError':
			return 'Upload failed';
		default:
			return 'Unsupported call';
	}
}
